import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { debounceTime, filter, map, shareReplay } from 'rxjs/operators';
import { AlertHostComponent } from '../../components/alert-host/alert-host.component';
import { AlertStoreService } from '../alert-store/alert-store.service';

@Injectable()
export class HostHandlerService {
  private _overlayRef: OverlayRef;
  private isInitialized: boolean;

  constructor(private allertsStore: AlertStoreService, private overlay: Overlay, private injector: Injector) {}

  init(): void {
    if (!this.isInitialized) {
      this.initService();
    }
  }

  private initService(): void {
    const hasAlerts$ = this.allertsStore.alertsState$.pipe(
      map((alertsState) => !!Object.keys(alertsState).length),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    const hideOverlay$ = hasAlerts$.pipe(
      debounceTime(1000),
      filter((hasAlerts) => !hasAlerts && !!this._overlayRef)
    );

    hideOverlay$.subscribe(() => {
      this._overlayRef.dispose();
      delete this._overlayRef;
    });

    hasAlerts$.pipe(filter((hasAlerts) => hasAlerts && !this._overlayRef)).subscribe(() => {
      const componentPortal = new ComponentPortal(AlertHostComponent, null, this.injector);
      this._overlayRef = this.overlay.create({
        hasBackdrop: false,
        panelClass: 'pointer-events-none',
        positionStrategy: this.overlay.position().global().top('10px').centerHorizontally(),
      });
      this._overlayRef.attach(componentPortal);
      this._overlayRef.overlayElement.parentElement.className += ' alert-host';
    });
  }
}
